import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import ButtonPrimary from 'components/ButtonPrimary/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'
import TextBodySmaller from 'components/TextBodySmaller.js'

const messages = defineMessages({
  trusted: {
    id: 'TrackCaloriesWhoItsBuiltForCTA.trusted',
    defaultMessage: '⭐ Trusted by 80,000+ fitness lovers worldwide.'
  },
  getStarted: {
    id: 'TrackCaloriesWhoItsBuiltForCTA.getStarted',
    defaultMessage: 'Get started'
  }
})

const ANALYTIC_EVENT = {
  TRACK_CALORIES_WHO_ITS_BUILT_FOR_GET_STARTED: 'TRACK_CALORIES_WHO_ITS_BUILT_FOR_GET_STARTED'
}

export const WhoItsBuiltForCTA = () => {
  const intl = useIntl()

  const handleClick = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.TRACK_CALORIES_WHO_ITS_BUILT_FOR_GET_STARTED)
  }

  return (
    <View mt={2}>
      <TextBodySmaller
        c='paragraph'
      >
        {formatMessageIntlUtil(intl, messages.trusted)}
      </TextBodySmaller>

      <View mt>
        <ButtonPrimary
          url={ROUTE_PATH.PREMIUM}
          onClick={handleClick}
          style={{
            margin: '0 auto'
          }}
        >
          {formatMessageIntlUtil(intl, messages.getStarted)}
        </ButtonPrimary>
      </View>
    </View>
  )
}
